import { render, staticRenderFns } from "./AdditionalQuestions.vue?vue&type=template&id=8584e584&"
import script from "./AdditionalQuestions.vue?vue&type=script&lang=js&"
export * from "./AdditionalQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports